<template>
    <el-dialog title="设置批发价" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="购买数量"  v-for="(item,index) in wholesaleList"  :key="index" >
                
                <el-col :span="6">
                      <el-input v-model="item.min_num" autocomplete="off" placeholder="最少起批数量" ></el-input>
                </el-col>
                 <el-col class="line" :span="1" style="text-align:center;">-</el-col>
                <el-col :span="6">
                     <el-input v-model="item.max_num" autocomplete="off" placeholder="最大起批数量" ></el-input>
                </el-col>
                <el-col class="line" :span="2">批发价：</el-col>
                <el-col :span="4">
                    <el-input v-model="item.wholesale_price"  placeholder="批发价格"  autocomplete="off"></el-input>
                </el-col>
                <el-button @click.prevent="removeWholesale(index)">删除</el-button>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button @click="addWholesale">新增批发规则</el-button>
            <el-button type="primary" @click="editWholesale" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ProductApi from '@/api/product.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                wholesaleList:[]
            };
        },
        props: ['is_open_wholesale','form'],
       
        created() {
            if(this.form.wholesale_price){
                this.wholesaleList = this.form.wholesale_price;
            }

            if(this.wholesaleList.length==0){

                this.wholesaleList.push({
                    min_num: '',
                    max_num: '',
                    wholesale_price:''
                });
            }           
            this.dialogVisible = this.$parent.is_open_wholesale;
        },
        methods: {
            
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            },
            addWholesale(){
                this.wholesaleList.push({
                    min_num: '',
                    max_num: '',
                    wholesale_price:''
                });
            },
            editWholesale(){
                let self =this;
                let params = {};
                params = this.form;
                let validateFlag = false;
                this.wholesaleList.forEach(function (item) {
                    if(!item.min_num && !item.max_num){
                         self.$message({
                            message: '批发数量不可都为空',
                            type: 'error'
                        });
                        validateFlag = true;
                        return false;
                    }
                    if(!item.wholesale_price){
                         self.$message({
                            message: '批发价格不可为空',
                            type: 'error'
                        });
                        validateFlag = true;
                        return false;
                    }
                    
                })
                if(validateFlag){
                    return false;
                }
                params.wholesale_price = JSON.stringify(this.wholesaleList);
                params.is_open_wholesale = params.is_open_wholesale=='false'?0:1;
                ProductApi.editSku(params, true)
                .then(data => {
                    self.loading = false;
                    self.dialogFormVisible(1);
                })
                .catch(error => {
                self.loading = false;
                });
                    
            },
            removeWholesale(index){
                // var index = this.wholesaleList.domains.indexOf(item)
                if (index !== -1) {
                    this.wholesaleList.splice(index, 1)
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/sku/part/Wholesale.vue